import { Foundation } from '@models';

export interface MyFoundationsResult {
  myFoundations: Foundation[];
}
